import React, { Suspense, useEffect, useRef } from "react";
import { Route, useHistory } from "react-router-dom";
import { ROUTE_CONSTANTS } from "../../constants/RouteConstants";
import { NavigateUserService } from "../../services/navigate-user-service/navigate-user.service";
import { TokenService } from "../../services/token-service/token.service";
import { Loader } from "../ui/loader/loader";

export const ProtectedRoute: React.FC<{
  component: React.FC<any>;
  path: string;
  exact?: boolean;
}> = ({ component: Component, path, exact }) => {
  const isMountRef = useRef(false);
  const history = useHistory();

  useEffect(() => {
    isMountRef.current = true;
    if (TokenService().getAccessToken()) {
      history.push(new NavigateUserService().getRoute());
    } else {
      history.push(ROUTE_CONSTANTS.LOGIN);
    }
    return () => {
      isMountRef.current = false;
    };
  }, []);

  return isMountRef.current ? (
    <Route
      path={path}
      exact={exact}
      render={() => (
        <Suspense fallback={<Loader loaderHeight="calc(100vh - 70px)" />}>
          <Component />
        </Suspense>
      )}
    />
  ) : (
    <Loader />
  );
};
